import React from 'react';
import { useReducedMotion } from 'framer-motion';
type FeatureVideoProps = {
  src: string;
  poster: string;
  background: string;
  label: string;
};
export function FeatureVideo({
  src,
  poster,
  background,
  label
}: FeatureVideoProps) {
  const reduceMotion = useReducedMotion();
  return <section aria-label={label} className="w-full px-5 py-10 md:px-10 md:py-16" style={{
    background
  }} data-id="element-90" data-mp="508zg3w6r1oh">
      <div className="mx-auto max-w-[1100px] overflow-hidden rounded-[10px] min-[700px]:rounded-[20px] shadow-[0px_12px_40px_rgba(0,0,0,0.18)]" data-id="element-91" data-mp="33i4id4mrp409">
        <video src={src} poster={poster} className="block h-auto w-full" autoPlay={!reduceMotion} muted loop playsInline preload="metadata" aria-label={label} data-id="element-92" data-mp="38gpmhf5547tz" />
      </div>
    </section>;
}